<template>
    <MenuLayout>
        <div v-if="loading">
            <LoadingSpinner />
        </div>
        <div v-else>
            <!-- Start of user register form -->
            <div class="row justify-content-center">
                <div class="card col-md-8 col-lg-8 col-sm-12 m-3 p-3 ">
                    <h4 class="fw-bold mb-4">User Detail Information</h4>
                    <div class="row mb-2">
                        <label class="text-start col-md-4">ID</label>
                        <div class="col-md-4 col-6">
                            <input type="text" class="form-control form-control-sm" v-model="userData.uid" :class="{ 'is-invalid': error.idError}" :disabled="search_switch"/>
                        </div>
                        <button class="btn btn-secondary search-btn" v-on:click.prevent="cancel()" v-if="search_switch">
                            Cancel
                        </button>
                        <button class="btn btn-success search-btn" v-on:click.prevent="show_data(userData.uid)" v-else>
                            Search
                        </button>
                    </div>
                    <div class="row mb-2">
                        <label class="text-start col-md-4">Name</label>
                        <div class="col-md-8 col-12">
                            <input type="text" class="form-control form-control-sm" v-model="userData.name" disabled />
                        </div>
                    </div>
                    <div class="row mb-2">
                        <label class="text-start col-md-4">Email</label>
                        <div class="col-md-8">
                            <input type="email" class="form-control form-control-sm" v-model="userData.email" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <label class="text-start col-md-4">Role</label>
                        <div class="col-md-8 col-12">
                            <input type="text" class="form-control form-control-sm" :value="selectedRole" disabled />
                        </div>
                    </div>
                </div>
                <div class="card col-md-8 col-lg-8 col-sm-12 m-3 p-3 ">
                    <h4 class="fw-bold mb-4">Access Permission</h4>
                    <label class="my-2 fw-bold"> 応募者一覧 </label>
                    <div class="row mb-2 ps-3">
                        <div class="col-4 mb-1">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.search" :checked="permission.search==1" disabled>
                                <div class="text-start">
                                    <label class="form-check-label">Search</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.download_list" :checked="permission.download_list==1">
                                <div class="text-start">
                                    <label class="form-check-label">Download List</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.set_interview" :checked="permission.set_interview==1">
                                <div class="text-start">
                                    <label class="form-check-label">Set Interview</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.multi_delete" :checked="permission.multi_delete==1">
                                <div class="text-start">
                                    <label class="form-check-label">Multi-Delete</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.download_cv" :checked="permission.download_cv==1">
                                <div class="text-start">
                                    <label class="form-check-label">Download CV</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.preview" :checked="permission.preview==1">
                                <div class="text-start">
                                    <label class="form-check-label">Preview</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mx-5">
                    <label class="my-2 fw-bold"> プレビュー </label>
                    <div class="row mb-2 ps-3">
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.preview_edit" :checked="permission.preview_edit==1">
                                <div class="text-start">
                                    <label class="form-check-label">Go to Edit</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.preview_download" :checked="permission.preview_download==1">
                                <div class="text-start">
                                    <label class="form-check-label">Download</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mx-5">
                    <label class="my-2 fw-bold">応募者登録</label>
                    <div class="row mb-2 ps-3">
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.app_create" :checked="permission.app_create==1">
                                <div class="text-start">
                                    <label class="form-check-label">Create</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.app_update" :checked="permission.app_update==1">
                                <div class="text-start">
                                    <label class="form-check-label">Update</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.app_delete" :checked="permission.app_delete==1">
                                <div class="text-start">
                                    <label class="form-check-label">Delete/Restore</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mx-5">
                    <label class="my-2 fw-bold"> 各種設定 </label>
                    <div class="row mb-2 ps-3">
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.setting_update" :checked="permission.setting_update==1" disabled>
                                <div class="text-start">
                                    <label class="form-check-label">Update</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mx-5">
                    <label class="my-2 fw-bold"> 職種登録 </label>
                    <div class="row mb-2 ps-3">
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.job_create" :checked="permission.job_create==1">
                                <div class="text-start">
                                    <label class="form-check-label">Create</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.job_update" :checked="permission.job_update==1">
                                <div class="text-start">
                                    <label class="form-check-label">Update</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="permission.job_delete" :checked="permission.job_delete==1">
                                <div class="text-start">
                                    <label class="form-check-label">Delete</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3" v-if="search_switch">
                        <button class="btn btn-primary" v-on:click.prevent="update_data()">
                            <span v-if="updateMode">Update</span>
                            <span v-else>Save</span>
                        </button>
                        <button class="btn btn-secondary me-0" v-on:click.prevent="cancel()">Cancel</button>
                    </div>
                </div>
            </div>
            <!-- End of user register form -->
        </div>
    </MenuLayout>
</template>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import timeoutMixin from '@/Util/timeoutMixin.js';
import ConstantVar from "@/Service/constant-var.js";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import Enum from "@/Service/enum.js";
import Swal from "sweetalert2";
import { swal_option } from "@/Util/swal-option.js";
import { msg_code } from "@/Util/msg_code.js";
var con_var = new ConstantVar();
var dataService = new DataService();
var config = new Configuration();
var enums = new Enum();
export default {
    mixins: [timeoutMixin],
    components: {
        MenuLayout,
        LoadingSpinner
    },
    data() {
        return {
            userData: {
                uid: null,
                name: null,
                email: null,
                role: ''
            },
            drop_down: {
                role: []
            },
            updateMode: false,
            selectedRole: '',
            permission : {},
            search_switch :false,
            error: {
                idError: false,
            },
        }
    },
    async mounted() {
        this.loading = con_var.LOADING_INTI;
        this.drop_down.role = enums.ROLE;
        this.loading = con_var.LOADING_END;
    },
    async created() {
        if (this.$route.params.uid) {
            this.userData.uid = this.$route.params.uid;
            this.show_data(this.userData.uid);
        }
        this.loading = false;
    },
    methods: {
        async update_data() {
            this.process_loading = true;
            this.loading_text = "Processing";
            var serverResponse;
            this.permission.updated_by = this.userID;
            serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_PERMISSION + "/" + this.userData.uid, this.permission);
            if (serverResponse.success == true) {
                Swal.fire(swal_option("success", serverResponse.message));
                this.cancel();
            }
            else if (serverResponse.success == false && serverResponse.error == false) {
                Swal.fire(swal_option("warn", serverResponse.message));
            }
            else {
                Swal.fire(swal_option("error", msg_code("ef001")));
            }
            this.loading_model = con_var.LOADING_MODEL;
            this.process_loading = false;
            this.loading_text = null;
        },
        async show_data(uid) {
            if (!this.userData.uid) {
                this.error.idError = true;
                return;
            }
            this.loading_model = { process_loading: true, loading_text: 'Processing' };
            this.updateMode = true;
            this.error.idError = false;
            this.search_switch = true;
            this.permission = {};
            var serverResponse= await dataService.retrieveWithGet(config.SERVICE_NAME_USER_PERMISSION + "/" + uid);
            if (serverResponse.success == true) {
            this.userData = serverResponse.data['user'];
            this.selectedRole = this.drop_down.role[this.userData.role];
            this.permission = serverResponse.data['permission'];
            }
            else if (serverResponse.success == false && serverResponse.error == false) {
                Swal.fire(swal_option("warn", serverResponse.message));
                this.cancel();
            }
            else {
                Swal.fire(swal_option("error", msg_code("ef001")));
            }
            this.loading_model = con_var.LOADING_MODEL;
        },
        cancel() {
            this.userData = {
                uid: null,
                name: null,
                email: null,
                role: ''
            };
            this.permission = {},
            this.selectedRole = '';
            this.updateMode = false;
            this.search_switch = false;
            this.error.idError = false;
            this.$router.push({ name: 'userPermission' });
        },
    },
};
</script>
